export class Ancora {
    idAnotacao: number;
    idAto: number;
    idSegmento: number;
    texto: string;
    dataInicioVigencia: string;
    dataRepublicacao: string;
    permiteExcluir: boolean;
    permiteAlterarData: boolean;
    ehAgendamento = true;
    textoAgendamento: string;
    exibirDataInicioVigencia: boolean;
    exibirEssaDataInicioVigencia = false;
    permiteAgendamento = true;
}